.phoneGroup {
  padding-bottom: 5px !important;
}

.notVerified {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #e07a00;
  padding: 0 0 12px 25px;
}

.withVerify :global(.input-field) {
  padding-bottom: 6px !important;
}

.verifyButton {
  background: none;
  border: none;
  padding: 0;
  margin-left: 4px;
  font-size: 12px;
  color: #e07a00;
  text-decoration: underline;
  cursor: pointer;
  font-family: inherit;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
}

.phoneInfo {
  padding: 0 25px 25px;
  font-size: 11px;
  line-height: 1.2em;
}

.companyGroup {
  padding: 30px 25px 20px;
  font-size: 16px;
  color: #CCC;
  background-color: white;
}

.emailInfo {
  font-size: 12px;
  line-height: 1.2em;
  color: #999;
  margin-top: 10px;
}

.wrapper {
  display: flex;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
  padding: 26px 25px 20px;
}

.marketingInfo {
  font-size: 11px;
}
